import React from 'react'
import * as S from './styles'

export type Props = {
  dataSource: {
    title: string
    desc: string | number | React.ReactElement | React.ReactElement[]
    suffix?: string | number | React.ReactElement
    suffixTheme?: 'downIcon'
    isHide?: boolean
  }[]
  style?: React.CSSProperties
  id?: string
}

export default function Description({ dataSource, ...props }: Props) {
  return (
    <S.DescComponent {...props}>
      <tbody>
        {dataSource.map((data, index) => {
          if (data.isHide) return ``

          return (
            <S.StyledTr key={index}>
              <S.StyledTitleTd>{data.title}</S.StyledTitleTd>
              <S.StyledTd>{data.desc}</S.StyledTd>
              <S.StyledTd tdTheme={data.suffixTheme}>{data.suffix}</S.StyledTd>
            </S.StyledTr>
          )
        })}
      </tbody>
    </S.DescComponent>
  )
}
